/**
 * muha-cross-sell.js
 * ──────────────────
 * Gestisce:
 *  1. Add-to-cart AJAX (pagina prodotto)
 *  2. Integrazione nativa Combine via KROWN.functions.eventDispatcher
 */

(function () {
  'use strict';

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function addToCart(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
    }).then(function (r) { return r.json(); });
  }

  // Notifica Combine del cambio carrello (usa KROWN nativo)
  function notifyCartUpdate() {
    if (window.KROWN && window.KROWN.functions && window.KROWN.functions.eventDispatcher) {
      window.KROWN.functions.eventDispatcher('cart:refresh', {});
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

    // Aggiorna counter header e attributi drawer
    fetchCart().then(function (cart) {
      document.querySelectorAll('[data-header-cart-count], [data-js-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
      });
      var drawer = document.getElementById('site-cart-sidebar');
      if (drawer) {
        drawer.setAttribute('data-cart-items', cart.item_count);
        drawer.classList.toggle('cart-is-empty', cart.item_count === 0);
      }
    }).catch(function () {});
  }

  // Click sul bottone cross-sell → ATC via fetch
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.muha-cross-sell__btn');
    if (!btn) return;
    e.preventDefault();

    var variantId    = btn.dataset.variantId;
    if (!variantId) return;

    var btnText      = btn.querySelector('.button__text');
    var defaultLabel = btn.dataset.defaultLabel || 'Aggiungi';
    var addedLabel   = btn.dataset.addedLabel   || '✓ Aggiunto';
    var productName  = btn.closest('.muha-cross-sell')
      ? (btn.closest('.muha-cross-sell').querySelector('.text-weight--bold') || {}).textContent
      : undefined;
    if (productName) productName = productName.trim();

    // Tracking: click sul modulo cross-sell
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'cross_sell_click',
      cross_sell_variant_id: variantId,
      cross_sell_product_name: productName
    });

    btn.disabled = true;
    btn.classList.add('is-loading');

    addToCart(variantId)
      .then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        if (btnText) btnText.textContent = addedLabel;

        // Tracking: aggiunta al carrello riuscita
        window.dataLayer.push({
          event: 'cross_sell_add_to_cart',
          cross_sell_variant_id: variantId,
          cross_sell_product_name: productName
        });

        notifyCartUpdate();

        setTimeout(function () {
          btn.disabled = false;
          btn.classList.remove('is-added');
          if (btnText) btnText.textContent = defaultLabel;
        }, 2500);
      })
      .catch(function (err) {
        console.error('[muha-cross-sell] Errore:', err);
        btn.disabled = false;
        btn.classList.remove('is-loading');
      });
  });

})();
